import Vue from 'vue'
import "../../assets/css/reset.css";
import '@/assets/js/rem.js'
import App from './app.vue'
import VConsole from 'vconsole'
if (location.href.indexOf('192.168') > -1) {
  new VConsole()
}
new Vue({
  render: h => h(App)
}).$mount('#app')